import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MeetingSummaryForLeadsAndDealsReportService {

  constructor(private http: HttpClient) { }

  ur1 = environment.serverAPI9 + "/api/meetingSummary";


  searchMeetingSummaryReport(query: string, page: number,
    size: number, sort: string, groupBy: any): Observable<any> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<any>(`${this.ur1}/condition/${queryParams}`, requestBody).pipe(
      map((res: any) => {
        if (res && res.content && Array.isArray(res.content)) {
          res.content = res.content.map((item: any) => {
            if (item.telephone !== undefined) {
              item['Lead Mobile Number'] = item.telephone;
              delete item.telephone;
            }
            if (item.sourceName !== undefined) {
              item['Lead Source'] = item.sourceName;
              delete item.sourceName;
            }
            if (item.leadStatusName !== undefined) {
              item['Lead Status'] = item.leadStatusName;
              delete item.leadStatusName;
            }
            if (item.dealCreatedAt !== undefined) {
              item['Deal Created Date'] = item.dealCreatedAt;
              delete item.dealCreatedAt;
            }
            if (item.dealUpdatedAt !== undefined) {
              item['Deal Updated Date'] = item.dealUpdatedAt;
              delete item.dealUpdatedAt;
            }
            if (item.dealStatusName !== undefined) {
              item['Deal Stage'] = item.dealStatusName;
              delete item.dealStatusName;
            }
            return item;
          });
        }
        return res;
      })
    );
  }
}
